
import React, { useEffect, useState } from "react";

import {
  Box,
  IconButton,
  makeStyles,
  Typography,
  useTheme,
} from "@material-ui/core";
import DataService from "../../../../Service";

const BORDER = "1px solid #70707040";

function ClientInvoicingDetails() {
  const classes = useStyles();

  const theme = useTheme();

  const supplierInvoiceDetails = [
    { title: "Name", desc: "Acuity Coaching Ltd" },
    {
      title: "Invoice Address",
      desc: "130, Helmshore Road, Holcombe Village, Bury, BL8 4PB",
    },
    { title: "Email", desc: "accounts@acuitycoaching.com" },
    { title: "Invoice Narrative", desc: "Sample text goes here" },
  ];
  const [apiData, setApiData] = useState([]);
  const [clientInvoicingSchedule, setClientInvoicingSchedule] = useState([]);
  const [clientInvoicingScheduleNo, setclientInvoicingScheduleNo] = useState([]);
  const [addOnsInvoicingSchedule, setAddOnsInvoicingSchedule] = useState([]);
  const [addOnsInvoicingScheduleNo, setaddOnsInvoicingScheduleNo] = useState([]);
  const [clientInvoicingOptions, setClientInvoicingOptions] = useState([]);
  const [clientInvoicingDetail, setClientInvoicingDetail] = useState([]);
  const [loading, setLoading] = useState(false);

  let urlElements = window.location.href.split('/');
  const InvoiceID = `${urlElements[5]}`;
  const getData = () => {
    const params = {
      invoice_id: InvoiceID
    }
    DataService.getDirectData(`/invoices/client_invoicing_details`, params).then((response) => {

      let listData = response.client_invoicing_basics;
      let clientInvoicingScheduleNo = response.client_invoicing_schedule.num_of_tranche;
      let clientInvoicingSchedule = response.client_invoicing_schedule.client_billing_schedules;
      let addOnsInvoicingScheduleNo = response.add_ons_invoicing_schedule.num_of_tranche;
      let addOnsInvoicingSchedule = response.add_ons_invoicing_schedule.add_ons_billing_schedules;
      let clientInvoicingOptions = response.client_invoicing_options;
      let clientInvoicingDetail = response.client_invoicing_detail;

      // let clientInvoicingSchedule = response.client_invoicing_schedule.client_billing_schedules;
      setApiData(listData);
      setclientInvoicingScheduleNo(clientInvoicingScheduleNo)
      setClientInvoicingSchedule(clientInvoicingSchedule)
      setaddOnsInvoicingScheduleNo(addOnsInvoicingScheduleNo)
      setAddOnsInvoicingSchedule(addOnsInvoicingSchedule)
      setClientInvoicingOptions(clientInvoicingOptions)
      setClientInvoicingDetail(clientInvoicingDetail)
      setLoading(false);
    })

      .catch((err) => { });
  };
  useEffect(() => {
    setLoading(true);
    getData();
  }, []);
  return (
    <div style={{ width: "100%" }}>
      <Box pb="16px" borderBottom={BORDER}>
        <Typography
          variant="body1"
          style={{ marginBottom: "14px" }}
          className={classes.heading}
        >
          Client invoicing basics
        </Typography>

        {apiData.length > 0 && apiData.map((item) => (
          <Typography key={item} variant="body1" className={classes.body}>
            {item}
          </Typography>
        ))}
      </Box>

      <Box
        width="100%"
        display="flex"
        mt="20px"
        pb="25px"
        borderBottom={BORDER}
      >
        <Box width="40%">
          <Typography
            variant="body1"
            style={{ marginBottom: "20px" }}
            className={classes.heading}
          >
            Client invoicing schedule
          </Typography>
          <Typography variant="body1" className={classes.body}>
            Tranche - <b>{clientInvoicingScheduleNo}</b>
          </Typography>
        </Box>

        <Box width="60%">
          <Typography
            variant="body1"
            style={{ marginBottom: "20px" }}
            className={classes.heading}
          >
            Client billing schedule
          </Typography>
          {clientInvoicingSchedule.length > 0 && clientInvoicingSchedule.map((item) => (
            <Typography key={item} variant="body1" className={classes.body}>
              {item.percentage} - {item.installment_type}
            </Typography>
          ))}
        </Box>
      </Box>

      <Box
        width="100%"
        display="flex"
        mt="20px"
        pb="25px"
        borderBottom={BORDER}
      >
        <Box width="40%">
          <Typography
            variant="body1"
            style={{ marginBottom: "20px" }}
            className={classes.heading}
          >
            Add-ons invoicing schedule
          </Typography>
          <Typography variant="body1" className={classes.body}>
            Tranche - <b>{addOnsInvoicingScheduleNo}</b>
          </Typography>
        </Box>

        <Box width="60%">
          <Typography
            variant="body1"
            style={{ marginBottom: "20px" }}
            className={classes.heading}
          >
            Add-ons billing schedule
          </Typography>
          {addOnsInvoicingSchedule.length > 0 && addOnsInvoicingSchedule.map((item) => (
            <Typography key={item} variant="body1" className={classes.body}>
              {item.percentage} - {item.installment_type}
            </Typography>
          ))}
        </Box>
      </Box>

      <Box pb="16px" mt="20px" borderBottom={BORDER}>
        <Typography
          variant="body1"
          style={{ marginBottom: "14px" }}
          className={classes.heading}
        >
          Client invoicing options
        </Typography>
        {clientInvoicingOptions.length > 0 && clientInvoicingOptions.map((item) => (
          <Typography variant="body1" className={classes.body}>
            {item}
          </Typography>
        ))}
      </Box>

      <Box width="100%" mt="20px">
        <Typography
          variant="body1"
          style={{ marginBottom: "20px" }}
          className={classes.heading}
        >
          Client invoicing details
        </Typography>
        <Box width="100%" display="flex" mb="45px">
          <Box width="20%" >
            <Typography
              variant="body1"
              className={classes.body}
              style={{ color: "#077f83" }}
            >
              Name
            </Typography>
            <Typography variant="body1" className={classes.body}>
              {clientInvoicingDetail.name}
            </Typography>
          </Box>
          <Box width="30%" >
            <Typography
              variant="body1"
              className={classes.body}
              style={{ color: "#077f83" }}
            >
              Invoice address
            </Typography>
            <Typography variant="body1" className={classes.body}>
              {clientInvoicingDetail.invoice_address}
            </Typography>
          </Box>
          <Box width="25%" >
            <Typography
              variant="body1"
              className={classes.body}
              style={{ color: "#077f83" }}
            >
              Email
            </Typography>
            <Typography variant="body1" className={classes.body}>
              {clientInvoicingDetail.email}
            </Typography>
          </Box>
          <Box width="20%" >
            <Typography
              variant="body1"
              className={classes.body}
              style={{ color: "#077f83" }}
            >
              Invoice narrative
            </Typography>
            <Typography variant="body1" className={classes.body}>
              {clientInvoicingDetail.invoice_narrative}
            </Typography>
          </Box>

        </Box>
      </Box>
    </div>
  );
}

export default ClientInvoicingDetails;

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: "bold",
    color: "#EF7000",
  },

  body: {
    fontSize: 14,
    lineHeight: "24px",
    marginBottom: 14,
    color: "#232323",
  },
}));
